class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();

    document.addEventListener("Shopify:section:load", (event) => {
      const section = event.target;
      console.log({ section });
      const customElement = section.querySelector("envelop-swicth");
      if (customElement) {
        customElement.connectedCallback?.();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    /* attach event listener to summary element */
    const cartDrawerNoteCheckbox = this.querySelector("#cart-note-checkbox");

    cartDrawerNoteCheckbox.addEventListener("click", function () {
      cartDrawerNote.click();
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner && drawerInner.classList.contains("is-empty")) {
      drawerInner.classList.remove("is-empty");
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      const customElement = sectionElement.querySelector("envelop-swicth");
      if (customElement) {
        customElement.connectedCallback?.();
      }
    });

    setTimeout(() => {
      const overlay = this.querySelector("#CartDrawer-Overlay");
      if (overlay) {
        overlay.addEventListener("click", this.close.bind(this));
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class EnvelopSwitch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("#envelopSwitch");
    this.sectionId = this.dataset.sectionId;
    this.boxProductId = this.querySelector("#boxProductId");
    this.envelopProductId = this.querySelector("#envelopProductId");
    this.boxPlanId = this.boxProductId?.dataset.planId;
    this.envelopPlanId = this.envelopProductId?.dataset.planId;
    this.cartItems = JSON.parse(this.dataset.cartItems);
    this.addEventListener("change", this.handleSwitch.bind(this));
  }

  handleSwitch(evt) {
    let prodId = null;
    let index = null;
    let selling_plan = null;
    if (evt.target.checked) {
      index = this.cartItems.findIndex(
        (item) => `${item.id}` == this.boxProductId?.value
      );
      prodId = this.envelopProductId?.value;
      selling_plan = this.envelopPlanId;
    }
    if (!evt.target.checked) {
      index = this.cartItems.findIndex(
        (item) => `${item.id}` == this.envelopProductId?.value
      );
      prodId = this.boxProductId?.value;
      selling_plan = this.boxPlanId;
    }

    if (index == 0) {
      //delete current product in cart
      let updates = {
        line: index + 1,
        quantity: 0,
      };

      //add new product to cart
      let data = {
        items: [
          {
            id: prodId,
            quantity: 1,
            selling_plan,
          },
        ],
      };

      this.handleSwitchProducts(updates, data);
    }
  }
  async handleSwitchProducts(updates, data) {
    try {
      this.input.setAttribute("disabled", "disabled");

      const updateResponse = await this.updateCart(updates);
      console.log("Cart updated:", updateResponse);

      // Agregar un nuevo producto
      const addResponse = await this.addToCart(data);
      console.log("Product added:", addResponse);

      await this.sectionRendering();
      console.log("Section re-rendered successfully");

      this.input.removeAttribute("disabled");
    } catch (error) {
      console.error("Error en handleSwitchProducts:", error);
    }
  }

  async updateCart(updates) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updates),
    }).then((response) => {
      if (!response.ok) throw new Error("Failed to update cart");
      return response.json();
    });
  }

  async addToCart(data) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) throw new Error("Failed to add to cart");
      return response.json();
    });
  }

  async sectionRendering() {
    return fetch(window.Shopify.routes.root + `?section_id=${this.sectionId}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch section");
        return res.text();
      })
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const drawerInner = doc.querySelector(".drawer__inner");
        const cartItemsSection = document.querySelector(
          `#shopify-section-${this.sectionId} .drawer__inner`
        );

        if (cartItemsSection && drawerInner) {
          cartItemsSection.innerHTML = drawerInner.innerHTML;
        }
      });
  }
}
if (!customElements.get("envelop-swicth")) {
  customElements.define("envelop-swicth", EnvelopSwitch);
}
